export default class ProductDetailSpecItemModel {
  constructor() {
    this.Name = '';

    this.Value = '';
  }
  getData(dataSource) {
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Name')) {
      this.Name = dataSource.Name;
    }
    if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, 'Value')) {
      this.Value = dataSource.Value;
    }

    return this;
  }
}
